import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import 'vuetify/styles';
import 'vuetify/dist/vuetify.min.css';
const vuetify = createVuetify({
    components
});

export default vuetify;
